/* ============================================================
   KDG Size Guide — motor de cálculo (reusa el algoritmo de Curveez)
   Inline, multi-instancia, con columnas informativas y modo solo-tabla.
   ============================================================ */
(function (root) {
  'use strict';

  function round(n) { return Math.round(n * 10) / 10; }
  function humanize(s) { return String(s).replace(/_/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); }); }
  function isNumericValue(v) { return v !== '' && v != null && isFinite(Number(v)); }

  // ¿La columna `key` es numérica (rango [min,max]) o informativa (string/lista)?
  function isNumericKey(config, key) {
    var ranges = config.ranges || [];
    for (var i = 0; i < ranges.length; i++) {
      var v = ranges[i][key];
      if (Array.isArray(v) && v.length) return v.every(isNumericValue);
    }
    return false;
  }
  function numericInputs(config) {
    return (config.inputs || []).filter(function (k) { return isNumericKey(config, k); });
  }
  // Campos de validación: se muestran como campo pero NO eligen talla ni son columna
  // de la tabla (p.ej. la cabeza en el arnés, que solo confirma que pase por el cuello).
  function checkInputs(config) {
    return (config.checks || []).map(function (c) { return c.input; });
  }

  // Conversión de la medida tecleada (en `unit`) a la unidad de almacenamiento del JSON.
  function toStorage(value, unit, storage) {
    if (unit === 'metric' && storage === 'in') return value / 2.54;
    if (unit === 'imperial' && storage === 'cm') return value * 2.54;
    return value;
  }
  // Conversión de un valor almacenado para mostrar según el toggle activo.
  function toDisplay(value, unit, storage) {
    var num = Number(value);
    if (!isFinite(num)) return value; // informativo (string) → literal
    if (storage === 'in' && unit === 'metric') return round(num * 2.54);
    if (storage === 'cm' && unit === 'imperial') return round(num / 2.54);
    return round(num);
  }

  // NÚCLEO: config + valores {key:num} (en `unit`) → { size } | { error }
  function computeSize(config, values, unit) {
    var storage = config.unit || 'cm';
    var inputs = numericInputs(config);
    var ranges = config.ranges || [];
    if (!inputs.length || !ranges.length) return { error: 'no-calc' };
    var missing = inputs.some(function (k) { var v = values[k]; return v == null || isNaN(v) || v <= 0; });
    if (missing) return { error: 'missing' };

    var bestIdx = -1;
    for (var i = 0; i < inputs.length; i++) {
      var key = inputs[i];
      var conv = toStorage(values[key], unit, storage);
      var found = -1;
      for (var r = 0; r < ranges.length; r++) {
        var range = ranges[r][key];
        if (!Array.isArray(range)) continue;
        if (conv <= range[1]) { found = r; break; }
      }
      if (found === -1) return { error: 'out-of-range' };
      if (found > bestIdx) bestIdx = found;
    }
    if (bestIdx < 0) return { error: 'out-of-range' };
    return { size: ranges[bestIdx].size };
  }

  // Rótulo de campo (formulario) y encabezado de columna (tabla) por medida.
  function fieldLabel(config, key) {
    var l = (config.labels || {})[key] || {};
    return l.field || l.column || humanize(key);
  }
  function columnLabel(config, key) {
    var l = (config.labels || {})[key] || {};
    return l.column || l.field || humanize(key);
  }

  function SizeGuide(rootEl, config) {
    this.root = rootEl;
    this.config = config;
    this.unit = 'metric';
    this.values = {};
    this.recommended = null;

    this.calcWrap = rootEl.querySelector('[data-sg-calc-wrap]');
    this.fieldsEl = rootEl.querySelector('[data-sg-fields]');
    this.tableEl = rootEl.querySelector('[data-sg-table]');
    this.resultEl = rootEl.querySelector('[data-sg-result]');
    this.resultSizeEl = rootEl.querySelector('[data-sg-result-size]');
    this.errorEl = rootEl.querySelector('[data-sg-error]');
    this.headNoteEl = rootEl.querySelector('[data-sg-head-note]');

    this.hasCalc = numericInputs(config).length > 0;
    // Modo solo-tabla (Correa): oculta todo el bloque de calculador.
    if (!this.hasCalc && this.calcWrap) this.calcWrap.setAttribute('hidden', '');

    if (this.hasCalc) this.renderFields();
    this.renderTable();
    this.bind();
  }

  SizeGuide.prototype.renderFields = function () {
    var self = this, config = this.config;
    var pid = this.root.getAttribute('data-sg') || '';
    var inputs = numericInputs(config).concat(checkInputs(config));
    // Orden explícito de los campos del formulario (config.field_order); los no listados van al final.
    var order = config.field_order;
    if (Array.isArray(order) && order.length) {
      inputs = order.filter(function (k) { return inputs.indexOf(k) !== -1; })
        .concat(inputs.filter(function (k) { return order.indexOf(k) === -1; }));
    }
    this.fieldsEl.innerHTML = inputs.map(function (key) {
      var unitLabel = self.unit === 'metric' ? 'cm' : 'in';
      var current = self.values[key];
      var value = (current != null && !isNaN(current)) ? current : '';
      var fid = 'sg-' + pid + '-' + key;
      return '<div class="kdg-sg__field">' +
        '<label class="kdg-sg__field-label" for="' + fid + '">' + fieldLabel(config, key) + '</label>' +
        '<input type="number" inputmode="decimal" step="0.1" min="0" class="kdg-sg__input" id="' + fid + '" ' +
          'data-sg-input="' + key + '" placeholder="Ej: en ' + unitLabel + '" value="' + value + '">' +
        '</div>';
    }).join('');
    this.fieldsEl.querySelectorAll('[data-sg-input]').forEach(function (input) {
      input.addEventListener('input', function (e) {
        var v = parseFloat(e.target.value);
        self.values[e.target.dataset.sgInput] = isNaN(v) ? undefined : v;
      });
    });
  };

  SizeGuide.prototype.renderTable = function () {
    var self = this, config = this.config;
    var inputs = config.inputs || [], ranges = config.ranges || [];
    var unitLabel = this.unit === 'metric' ? 'cm' : 'in';

    var thead = '<thead><tr><th>Talla</th>' + inputs.map(function (key) {
      var suffix = isNumericKey(config, key) ? ' (' + unitLabel + ')' : '';
      return '<th>' + columnLabel(config, key) + suffix + '</th>';
    }).join('') + '</tr></thead>';

    var tbody = '<tbody>' + ranges.map(function (row) {
      var cells = inputs.map(function (key) {
        var v = row[key];
        if (Array.isArray(v)) {
          if (!isNumericKey(config, key)) return '<td>' + v.join(', ') + '</td>';
          return '<td>' + toDisplay(v[0], self.unit, config.unit || 'cm') + ' – ' + toDisplay(v[1], self.unit, config.unit || 'cm') + '</td>';
        }
        return '<td>' + (v == null ? '—' : v) + '</td>'; // informativo de valor único
      }).join('');
      var rec = self.recommended && row.size === self.recommended;
      return '<tr' + (rec ? ' class="kdg-sg__row--rec"' : '') + '><td>' + row.size + '</td>' + cells + '</tr>';
    }).join('') + '</tbody>';

    this.tableEl.innerHTML = thead + tbody;
  };

  SizeGuide.prototype.setUnit = function (unit) {
    if (this.unit === unit || !this.hasCalc) return;
    var from = this.unit; this.unit = unit;
    var self = this;
    Object.keys(this.values).forEach(function (key) {
      var v = self.values[key];
      if (v == null || isNaN(v)) return;
      self.values[key] = (from === 'metric') ? round(v / 2.54) : round(v * 2.54);
    });
    this.root.querySelectorAll('[data-sg-unit]').forEach(function (btn) {
      var active = btn.dataset.sgUnit === unit;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', String(active));
    });
    this.recommended = null; // limpia el resaltado; el resultado se recalcula con "Calcular"
    this.hideMessages();
    this.renderFields();
    this.renderTable();
  };

  SizeGuide.prototype.hideMessages = function () {
    if (this.errorEl) this.errorEl.setAttribute('hidden', '');
    if (this.resultEl) this.resultEl.setAttribute('hidden', '');
    if (this.headNoteEl) this.headNoteEl.setAttribute('hidden', '');
  };

  SizeGuide.prototype.calculate = function () {
    this.hideMessages();
    // Los campos de validación (p.ej. cabeza) también son obligatorios.
    var self = this;
    var missingCheck = (this.config.checks || []).some(function (c) {
      var v = self.values[c.input];
      return v == null || isNaN(v) || v <= 0;
    });
    var out = computeSize(this.config, this.values, this.unit);
    if (out.error || missingCheck) {
      this.recommended = null;
      this.renderTable();
      if (this.errorEl) this.errorEl.removeAttribute('hidden');
      return;
    }
    this.recommended = out.size;
    if (this.resultSizeEl) this.resultSizeEl.textContent = out.size;
    if (this.resultEl) this.resultEl.removeAttribute('hidden');
    this.renderTable(); // resalta la fila recomendada
    this.runChecks(out.size);
  };

  // Validaciones que NO cambian la talla, solo avisan (que la cabeza pase por el cuello).
  // Compara cada check.input contra el máximo del rango `fits_in` de la talla recomendada.
  SizeGuide.prototype.runChecks = function (size) {
    var checks = this.config.checks || [];
    if (!checks.length || !this.headNoteEl) return;
    var self = this, config = this.config, storage = config.unit || 'cm', ranges = config.ranges || [];
    var unitLabel = this.unit === 'metric' ? 'cm' : 'in';

    var recIdx = -1;
    for (var i = 0; i < ranges.length; i++) { if (ranges[i].size === size) { recIdx = i; break; } }
    if (recIdx < 0) return;

    var lines = [], anyWarn = false;
    checks.forEach(function (c) {
      var val = self.values[c.input];
      if (val == null || isNaN(val) || val <= 0) return;
      var recRange = ranges[recIdx][c.fits_in];
      if (!Array.isArray(recRange)) return;
      var conv = toStorage(val, self.unit, storage);
      var recMax = recRange[1];
      var valDisp = round(val), maxDisp = toDisplay(recMax, self.unit, storage);
      if (conv <= recMax) {
        lines.push('✓ La cabeza pasa sin problema por esta talla.');
      } else {
        anyWarn = true;
        var suggest = null;
        for (var r = 0; r < ranges.length; r++) {
          var rr = ranges[r][c.fits_in];
          if (Array.isArray(rr) && conv <= rr[1]) { suggest = ranges[r].size; break; }
        }
        if (suggest) {
          lines.push('⚠️ La cabeza de tu perro (' + valDisp + ' ' + unitLabel + ') es más ancha que el cuello de la talla ' + size + ' (máx ' + maxDisp + ' ' + unitLabel + '). Para que el arnés pase por la cabeza, te recomendamos la talla ' + suggest + '.');
        } else {
          lines.push('⚠️ La cabeza de tu perro (' + valDisp + ' ' + unitLabel + ') excede el rango de todas las tallas. Escríbenos y te ayudamos a elegir.');
        }
      }
    });

    if (!lines.length) return;
    this.headNoteEl.innerHTML = lines.map(function (t) { return '<p class="kdg-sg__head-note-line">' + t + '</p>'; }).join('');
    this.headNoteEl.classList.toggle('is-warn', anyWarn);
    this.headNoteEl.classList.toggle('is-ok', !anyWarn);
    this.headNoteEl.removeAttribute('hidden');
  };

  SizeGuide.prototype.bind = function () {
    var self = this;
    this.root.querySelectorAll('[data-sg-unit]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.setUnit(btn.dataset.sgUnit); });
    });
    var calc = this.root.querySelector('[data-sg-calc]');
    if (calc) calc.addEventListener('click', function () { self.calculate(); });
  };

  // Controlador de tabs de categoría (Arnés/Collar/Correa).
  function initTabs(scope) {
    (scope || document).querySelectorAll('[data-sg-tabs]').forEach(function (tabsEl) {
      if (tabsEl.dataset.sgTabsReady) return;
      tabsEl.dataset.sgTabsReady = '1';
      var group = tabsEl.closest('[data-sg-group]') || document;
      tabsEl.querySelectorAll('[data-sg-tab]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.dataset.sgTab;
          tabsEl.querySelectorAll('[data-sg-tab]').forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-selected', String(on));
          });
          group.querySelectorAll('[data-sg-panel]').forEach(function (p) {
            if (p.dataset.sgPanel === id) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
          });
        });
      });
    });
  }

  function initGuides(scope) {
    var configs = window.__kdgSizeGuideConfigs || {};
    (scope || document).querySelectorAll('[data-sg]').forEach(function (el) {
      if (el.dataset.sgReady) return;
      var pid = el.getAttribute('data-sg');
      var cfg = configs[pid];
      if (!cfg) return;
      el.dataset.sgReady = '1';
      // try/catch: una instancia con problema no debe tumbar el init de tabs ni de las demás.
      try { new SizeGuide(el, cfg); } catch (e) { if (window.console) console.error('KDG SizeGuide init error', pid, e); }
    });
  }

  function init() { initGuides(document); initTabs(document); }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(); });
  }

  // Export para test node
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { computeSize: computeSize, isNumericKey: isNumericKey, numericInputs: numericInputs, toDisplay: toDisplay, humanize: humanize };
  }

  root.__kdgSizeGuideEngine = { computeSize: computeSize, isNumericKey: isNumericKey, numericInputs: numericInputs, toDisplay: toDisplay, humanize: humanize };
})(typeof window !== 'undefined' ? window : this);
